import axios from "axios";
import { endpoints } from "../config/api";
import axiosErrorHandler from "./axiosHelpers";
import { axiosInstance, axiosInstanceWithoutToken } from "./utilities";

export const loginWithMobile = async (body) => {
  const request = await axiosInstance
    .post(endpoints.auth.LOGIN_MOBILE_NUMBER, body)
    .catch((e) => {
      return axiosErrorHandler(e, "redirectToRegister");
    });
  return request;
};

export const loginWithEmail = async (body) => {
  const request = await axiosInstance
    .post(
      endpoints.auth.LOGIN_EMAIL,

      body
    )
    .catch(axiosErrorHandler);
  return request;
};

export const verifyOtp = async (body) => {
  const request = await axiosInstance
    .post(
      endpoints.auth.VERIFY_OTP,

      body
    )
    .catch((e) => {
      return axiosErrorHandler(e, "verifyOtp");
    });
  return request;
};

export const ccgSendOtp = async (body) => {
  const request = await axiosInstance
    .post(
      endpoints.customer.CUSTOMER_SEND_OTP,
      // headers: {
      //   Authorization: `Bearer ${localStorage.getItem("token")}` ?? "",
      //   createdFrom: "WEB",
      // },
      body
    )
    .catch(axiosErrorHandler);
  
  return request;
};

export const forgotPassword = async (data, token) => {
  let request = await axiosInstance
    .post(endpoints.auth.FORGET_PASSWORD, data)
    .catch((e) => {
      return axiosErrorHandler(e, "forgot");
    });

  
  return request;
};

export const resetPassword = async (data, token) => {
  let request = await axiosInstance.post(
    endpoints.auth.RESET_PASSWORD,

    data
  );
  return request;
};

export const CcgProposalData = async (params) => {
  let request = await axiosInstance.get(
    endpoints.auth.CCG_PROPOSAL_DETAIL,
    { params  }
  )
  return request;
};

export const CcgApprovalStatus = async (params) => {
  let request = await axiosInstance.get(
    endpoints.auth.CCG_APPROVAL_STATUS,
    { params }
  );
  return request;
};

export const CcgProposalStatus = async (params) => {
  let request = await axiosInstance.get(
    endpoints.auth.CCG_PROPOSAL_STATUS,
    { params }
  );
  return request;
};

export const CcgAddendumProposalStatus = async (params) => {
  let request = await axiosInstance.get(
    endpoints.auth.CCG_ADDENDUM_STATUS,
    { params }
  );
  return request;
};

export const CcgApproval = async (params) => {
  let request = await axiosInstance.get(
    endpoints.auth.CCG_Approval,
    { params }
  );
  return request;
};

export const CcgApprovalAgreement = async (params) => {
  let request = await axiosInstance.get(
    endpoints.auth.CCG_AGREEMENT_DATA,
    { params }
  );
  return request;
};

export const CcAddendum = async (params) => {
  let { status, contractId, email } = params;

  let request = await axiosInstance.put(
    `${endpoints.auth.CCG_Addendum}?status=${status}&contractId=${contractId}&email=${email}`
  );
  return request;
};

export const getUserDetails = async (body) => {
  const request = await axiosInstance
    .post(
      endpoints.auth.GET_USER,

      body
    )
    .catch(axiosErrorHandler);
  return request;
};

export const updatePassword = async (body) => {
  const request = await axiosInstance
    .post(
      endpoints.auth.UPDATE_PASSWORD,

      body
    )
    .catch(axiosErrorHandler);
  return request;
};

const navigator_info = window.navigator;
const screen_info = window.screen;
let uid = navigator_info.mimeTypes.length;
uid += navigator_info.userAgent.replace(/\D+/g, "");
uid += navigator_info.plugins.length;
uid += screen_info.height + "";
uid += screen_info.width + "";
uid += screen_info.pixelDepth || "";


let agent = navigator.userAgent;

const token = localStorage.getItem("token");

const dataIP = await getPublicIPMethod();
// const dataIP = null;

async function getPublicIPMethod() {
  return new Promise((resolve, reject) => {
    // Simulate an asynchronous operation
    setTimeout(async () => {
  try {
    const response = await fetch('https://ipinfo.io/json');
    const data = await response.json();
    resolve(data.ip || null);
  } catch (error) {
    console.error("Failed to fetch IP:", error);
    resolve(null); // ensure app doesn't break
  }
}, 500);
  });
}

export const signUpNewUser = async (body) => {
  // const request = await axiosInstance.post(
  //   endpoints.customer.CUSTOMER_ONBOARD,
  //   body,
  // ).catch((e) => {
  //   return axiosErrorHandler(e, "REGISTER");
  // });
  // return request;
  let request = await axios({
    method: "post",
    url: endpoints.customer.CUSTOMER_ONBOARD,
    headers: {
      updatedFrom: "WEB",
      createdFrom: "WEB",
      deviceid: uid,
      ip: dataIP,
      userAgent: agent,
    },
    data: body,
  }).catch(axiosErrorHandler);
  return request;
};

export const notificationList = async (params) => {
  const request = await axiosInstance
    .get(
      endpoints.notification.NOTIFICATION_LIST,

      { params }
    )
    .catch(axiosErrorHandler);
  return request;
};

export const notificationUpdate = async (body, params) => {
  const request = await axiosInstance
    .put(
      `${endpoints.notification.NOTIFICATION_UPDATE}${
        Boolean(params) ? `?id=${params}` : ""
      }`,

      body
    )
    .catch(axiosErrorHandler);
  return request;
};
